import { IconLookup, IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames, { Value as ClassValue } from "classnames";
import React from "react";

export function ButtonIcon(props: {
  icon: IconProp;
  className?: ClassValue;
  style?: React.CSSProperties;
  onClick?: () => void;
}) {
  return (
    <span
      className={classNames("icon is-small", props.className)}
      style={props.style}
      onClick={props.onClick}
    >
      <FontAwesomeIcon icon={props.icon} />
    </span>
  );
}

export function SmallIconButton(props: {
  icon: IconLookup;
  onClick: () => unknown;
  buttonStyle?: React.CSSProperties;
  isDisabled?: boolean;
}) {
  const disabledStyle = props.isDisabled === true ? { color: "lightgray" } : {};
  return (
    <button
      onClick={props.onClick}
      disabled={props.isDisabled ?? false}
      style={{
        padding: 5,
        borderWidth: 0,
        cursor: "pointer",
        backgroundColor: "transparent",
        ...props.buttonStyle,
        ...disabledStyle,
      }}
    >
      <ButtonIcon style={{ fontSize: "1rem" }} icon={props.icon} />
    </button>
  );
}
